<nav class="sb_main" aria-label="MRF navigation">
  <ul class="sb_main__list">
    <li>
      <a
        routerLink="/hrDetails/mrfDashboard"
        routerLinkActive="sb_main__link--active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="sb_main__link"
        title="MRF Dashboard"
        aria-label="MRF Dashboard"
      >
        <svg
          class="sb_main__icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            id="btn_home"
            d="M6 19H9.692V13.923C9.692 13.6943 9.76967 13.5027 9.925 13.348C10.0797 13.1927 10.2713 13.115 10.5 13.115H13.5C13.7287 13.115 13.9207 13.1927 14.076 13.348C14.2307 13.5027 14.308 13.6943 14.308 13.923V19H18V10.308C18 10.2053 17.9777 10.112 17.933 10.028C17.8883 9.94399 17.8273 9.87066 17.75 9.80799L12.366 5.74999C12.2633 5.66066 12.1413 5.61599 12 5.61599C11.8587 5.61599 11.737 5.66066 11.635 5.74999L6.25 9.80799C6.17333 9.87199 6.11233 9.94532 6.067 10.028C6.02167 10.1107 5.99933 10.204 6 10.308V19ZM5 19V10.308C5 10.052 5.05733 9.80966 5.172 9.58099C5.28667 9.35232 5.44467 9.16399 5.646 9.01599L11.031 4.93799C11.313 4.72266 11.635 4.61499 11.997 4.61499C12.359 4.61499 12.683 4.72266 12.969 4.93799L18.354 9.01499C18.556 9.16299 18.714 9.35166 18.828 9.58099C18.9427 9.80966 19 10.052 19 10.308V19C19 19.268 18.9003 19.5017 18.701 19.701C18.5017 19.9003 18.268 20 18 20H14.116C13.8867 20 13.6947 19.9227 13.54 19.768C13.3853 19.6127 13.308 19.4207 13.308 19.192V14.116H10.692V19.192C10.692 19.4213 10.6147 19.6133 10.46 19.768C10.3053 19.9227 10.1137 20 9.885 20H6C5.732 20 5.49833 19.9003 5.299 19.701C5.09967 19.5017 5 19.268 5 19Z"
            fill="currentColor"
          />
        </svg>
      </a>
    </li>
    <li *ngIf="showBudgetNav">
      <a
        routerLink="/hrDetails/mrfBudgetReport"
        routerLinkActive="sb_main__link--active"
        class="sb_main__link"
        [class.sb_main__link--disabled]="!canAccessHrmsBudgetReport"
        title="Manpower Budget Report"
        aria-label="Manpower Budget Report"
        (click)="onHrmsBudgetReportNav($event)"
      >
        <svg
          class="sb_main__icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M4 19V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M4 19H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M8 16V11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          <path d="M12 16V8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          <path d="M16 16V13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        </svg>
      </a>
    </li>
    <li *ngIf="showBudgetNav">
      <a
        routerLink="/hrDetails/budgetReport"
        routerLinkActive="sb_main__link--active"
        class="sb_main__link"
        [class.sb_main__link--disabled]="!canAccessBudgetForm"
        title="Budget Report"
        aria-label="Budget Report"
        (click)="onBudgetReportNav($event)"
      >
        <svg
          class="sb_main__icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M4 8.5C4 7.11929 5.11929 6 6.5 6H17.5C18.8807 6 20 7.11929 20 8.5V15.5C20 16.8807 18.8807 18 17.5 18H6.5C5.11929 18 4 16.8807 4 15.5V8.5Z"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <path d="M4 10H20" stroke="currentColor" stroke-width="1.5" />
          <circle cx="15.5" cy="13.5" r="1.75" stroke="currentColor" stroke-width="1.4" />
        </svg>
      </a>
    </li>
    <!-- <li>
      <a
        routerLink="/hrDetails/employeeWithdrawal"
        routerLinkActive="sb_main__link--active"
        class="sb_main__link"
        [class.sb_main__link--disabled]="!canAccessEmployeeWithdrawal"
        title="Employee Withdrawal"
        aria-label="Employee Withdrawal"
        (click)="onEmployeeWithdrawalNav($event)"
      >
        <svg
          class="sb_main__icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
            fill="currentColor"
          />
          <path
            d="M17 10H19V12H21V14H19V16H17V14H15V12H17V10Z"
            fill="currentColor"
          />
        </svg>
      </a>
    </li> -->
  </ul>
</nav>
